<template>
	<div
		class="checkable input"
		:class="[columns >= 1 && columns <= 4 ? 'inner-col inner-col--' + columns : 'checkable--inline']"
	>
		<template v-if="readonly">
			<template v-if="columns > 0">
				<template v-for="item in options">
					<div v-if="internalValue.indexOf(item.value) >= 0" :key="item.value" class="is-read-only">{{ item.value }}</div>
				</template>
			</template>
			<div v-else class="is-read-only">
				<template v-for="(item, index) in options.filter(item => internalValue.indexOf(item.value) >= 0)">{{ index ? ', ' : '' }}{{ item.value }}</template>
			</div>
		</template>
		<template v-else>
			<ElCheckboxGroup v-model="internalValue" @change="handleChange">
				<ElCheckbox v-for="item in options" :key="item.value" :label="item.value"> <Inline v-if="item.icon" :svg="item.icon" class="text-icon-subtle mr-2 mb-1" />{{ item.displayValue ?? item.value }}</ElCheckbox>
				<ElCheckbox v-if="allowOther" class="checkable__allow-other" :label="otherValue" @change="otherChange">
					<el-input ref="other" v-model="otherValue" :placeholder="$resource('field-choice-other-fill-in')" @focus="otherSelected" @input="otherSelected" />
				</ElCheckbox>
			</ElCheckboxGroup>
		</template>
	</div>
</template>

<script lang="ts">
	import { defineComponent, ref, watch } from 'vue';
	import { CheckboxGroup, Checkbox } from '@cognitoforms/element-ui';

	export default defineComponent({
		name: 'CCheckboxGroup',
		components: {
			ElCheckboxGroup: CheckboxGroup,
			ElCheckbox: Checkbox
		},
		inheritAttrs: false,
		model: {
			prop: 'value',
			event: 'change'
		},
		props: {
			value: {
				type: Array,
				default: () => []
			},
			columns: {
				type: Number,
				default: 0
			},
			readonly: Boolean,
			native: Boolean,
			allowOther: Boolean,
			options: {
				type: Array,
				default: null
			}
		},
		emits: ['change'],
		setup(props, { emit }) {
			const other = ref(null);
			const internalValue = ref(props.value);
			const otherValue = ref<string>('');

			const otherSelected = () => {
				// Remove options that are not valid
				internalValue.value = internalValue.value.filter(v => props.options.some(o => o.value === v));

				// Add the other value if it is not already in the list
				if (otherValue.value && !internalValue.value.some(v => v === otherValue.value)) {
					internalValue.value.push(otherValue.value);
				}
				emit('change', internalValue.value);
			};
			const otherChange = (otherSelected) => {
				if (otherSelected) {
					other.value.focus();
				}
			};
			const handleChange = (value, ev) => {
				internalValue.value = value;
				emit('change', value, ev);
			};

			watch(() => props.value, (valueProp) => {
				internalValue.value = valueProp;
			});
			return {
				internalValue,
				otherValue,
				otherSelected,
				otherChange,
				handleChange,
				other
			};
		}
	});
</script>